import { useFocusEffect } from '@react-navigation/native';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { StyleSheet } from "react-native";
import Joyride, { ACTIONS, CallBackProps, EVENTS, ORIGIN, STATUS } from 'react-joyride';
import getGlobalStyles from '../../globalStyles';
import { useThemeSettings } from '../../ThemeProvider';
import { useTranslation } from 'react-i18next';
import { TOUR_TYPES, useTourStore, getSteps } from '../../store/useTourStore';
import { useNavStore } from '../../store/navStore';
import { ROUTES } from '../../shared/constants/routes';
import { usePlatform } from '../../providers/PlatformProvider';
import { trackInteraction } from '../../analytics/analyticsUtil';
import { ACTION_TYPE, ANALYTICS_EVENT } from '../../analytics/types';


export default function WebTour({ children }) {
  const { theme } = useThemeSettings();
  const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);
  const { t } = useTranslation();
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const { hasSeen, setSeen } = useTourStore();
  const { getCurrentRoute } = useNavStore();
  const route = getCurrentRoute();
  const [activeTour, setActiveTour] = useState<TOUR_TYPES>(TOUR_TYPES.ONBOARDING);
const {showWebVersion} = usePlatform();
  useEffect(() => {
    const params = route?.params as any;
    switch (route?.name) {
      case ROUTES.RADIO_PLAYER:
        setActiveTour(TOUR_TYPES.AUDIO_PLAYER);
        break;
      case ROUTES.IMMERSRSIVE_NEWS_ARTICLE:
        if (params?.articleId)
          setActiveTour(TOUR_TYPES.NEWS_DETAILS);
        break;
      case ROUTES.HOME:
        if (params?.selectedTab === ROUTES.LISTEN && params?.articleId)
          setActiveTour(TOUR_TYPES.RADIO_HOME);
        break;
    }

  }, [route?.name, route?.params])
  useFocusEffect(
    useCallback(() => {
      if (!hasSeen(activeTour)) {
        requestAnimationFrame(() => {
          if (activeTour === TOUR_TYPES.NEWS_DETAILS) {
            setTimeout(() => {
              setRun(true)
            }, 1000);
          } else {
            setRun(true)
          }
        });
      }

      return () => {
        setRun(false);
        setStepIndex(0);
      };
    }, [activeTour])
  );
  const appStyles = {
    buttonNext: {
      ...gStyles.buttonStyle,
      ...gStyles.buttonActiveStyle,
      ...gStyles.buttonActiveLabelStyle,
      ...styles.button
    },
    buttonBack: {
      ...gStyles.buttonStyle,
      ...gStyles.buttonLabelStyle,
      ...styles.button,
      backgroundColor:  'transparent',
      borderColor: theme.colors.primary,
      color: theme.colors.primary,
    },
    beaconInner: { backgroundColor: theme.colors.primary },
    beaconOuter: { backgroundColor: theme.colors.primaryLight2 },
  }
  const lables = {
    back: t("screens.tour.back"),
    close: t("screens.tour.close"),
    last: t("screens.tour.last"),
    next: t("screens.tour.next"),
    nextLabelWithProgress: t("screens.tour.nextLabelWithProgress"),// 'Next (Step {step} of {steps})',
    // open: 'Open the dialog',
    skip: t("screens.tour.skip"),
  }
  const handleJoyrideCallback = (data: CallBackProps) => {
    const { action, index, origin, status, type } = data;

    if (action === ACTIONS.CLOSE && origin === ORIGIN.KEYBOARD) {
      // do something
    }

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      trackInteraction({
        event: ANALYTICS_EVENT.INTERACTION,
        action: ACTION_TYPE.CLICK,
        screen_name: route?.name as ROUTES,
        component: "ProductTourJoyride",
        context: {
          flow: "product_tour",
          cta: status === STATUS.SKIPPED ? "PRODUCT_TOUR_SKIP" : "PRODUCT_TOUR_COMPLETE",
          tour_type: activeTour,
        },
      });
      // You need to set our running state to false, so we can restart if we click start again.
      setSeen(activeTour)
      setRun(false);
      setStepIndex(0);
    }
  };

  const defaultOptions = {
    arrowColor: '#fff',
    backgroundColor: '#fff',
    beaconSize: 36,
    // overlayColor: 'red',
    primaryColor: '#f04',
    spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
    textColor: '#333',
    width: undefined,
    zIndex: 100,
  };
  return (
    <>
      <Joyride
        key={activeTour}
        callback={handleJoyrideCallback}
        steps={getSteps(t, activeTour, showWebVersion)}
        stepIndex={stepIndex}
        run={run}
        continuous
        showProgress
        showSkipButton
        locale={lables}
        disableCloseOnEsc
        disableOverlayClose
        styles={{ options: defaultOptions, ...styles, ...appStyles }}
        floaterProps={{
          options: {
            preventOverflow: {
              boundariesElement: 'viewport',
            }
          },
        }}
      />
      {children}
    </>
  );
}
const styles = StyleSheet.create({
  button: {
    minWidth: 100,
    height: 'auto',
    lineHeight: 1
  },
  tooltipContainer: {
    textAlign: "left",
  },
  beacon: {},
  buttonClose: {
    display: "none",
  },
  buttonSkip: {},
  overlay: {},
  overlayLegacy: {},
  overlayLegacyCenter: {},
  spotlight: {},
  spotlightLegacy: {},
  tooltip: {},
  tooltipContent: { padding: 0, paddingRight: 20 },
  tooltipFooter: {},
  tooltipFooterSpacer: {},
  tooltipTitle: {},
});
